export function uniq<T>(setA: T[]) {
  return new Set(setA);
}
